import * as React from 'react';

// Types
import { WithToastProps } from '@shopee-user/with-toast';
import { WithUserWebViewProps } from '@shopee-user/with-web-view';
import { ThirdPartyAuthenticationComponentsProps } from '@shopee-user/business-customization-types';

type Props = ThirdPartyAuthenticationComponentsProps &
  Pick<WithToastProps, 'showToast'> &
  Pick<WithUserWebViewProps, 'webViewOpenExternalLink'>;

export default function ThirdPartyAuthenticationComponents(_: Props) {
  return <></>;
}
